module.exports = require("@wildboar/x500/src/lib/modules/DirectoryIDMProtocols/dsp-ip.oa");